export const GROUPING_DONE_REQUEST = "GROUPING_DONE_REQUEST";
export const GROUPING_DONE_SUCCESS = "GROUPING_DONE_SUCCESS";
export const GROUPING_DONE_FAILED = "GROUPING_DONE_FAILED";
